import { render } from "./Basic.vue?vue&type=template&id=59b40f89"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
script.render = render

export default script